module.exports = __webpack_public_path__ + "static/media/MaskGroup.59acf112.png";